import React, { useState, useEffect } from 'react'
import { Controller, useForm } from 'react-hook-form'
import { Table, Icon, Modal, Button, Row, Col, Input, Checkbox, Drawer } from 'rsuite'

import ModalDurableArticles from './ModalDurableArticles'
import { budgetFormat } from '../../../utils/formatterUtil'
import { numberThousandSeparator } from '../../../utils/formatterUtil'
import { doneLoading, startLoading } from '../../../utils/loading'
import {
  approveRegisterAsset,
  createRegisterNumber,
  getAssetRegisterWaittingApproveByRequestId,
} from '../../../redux/actions/addDurableArticles'
import notification from '../../../utils/notification'
import { DEFAULT_ERR_MSG } from '../../../constants/msgText'
import CancelButton from '../../../components/buttons/cancelButton/CancelButton'
import SaveButton from '../../../components/buttons/saveButton/SaveButton'
import OverlayLoader from '../../../components/OverlayLoader/OverlayLoader'
import InputForm from '../../../components/forms/input/InputForm'
import EditButton from '../../../components/buttons/editButton/EditButton'
import ConfirmWidget from '../../confirm/ConfirmWidget'

export default function ListDurableArticlesWidgetTable({
  schema,
  onReload = () => {},
  loading,
  isViewMode,
  ...props
}) {
  const { register, handleSubmit, errors, control, setError, getValues, setValue, clearErrors } =
    useForm()
  const { Column, HeaderCell, Cell } = Table
  const [tableData, setTableData] = useState([])
  const [isAddNumberList, setIsAddNumberList] = useState(false)
  const [isConfirmAddNumber, setIsConfirmAddNumber] = useState(false)
  // const [modalSchema, setModalSchema] = useState(schema.values2)
  const [isConfirm, setIsConfirm] = useState(0)

  const [isLoading, setIsLoading] = useState(loading)
  const [actionType, setActionType] = useState()
  const [assetSchema, setAssetSchema] = useState()

  const [saveLoading, setSaveLoading] = useState()
  const [registerId, setRegisterId] = useState()

  const [selectedList, setSelectedList] = useState([])

  const [approveType, setApproveType] = useState([])
  const [approveSelected, setApproveSelected] = useState([])

  useEffect(() => {
    setTableData(schema.values)
  }, [schema.values])

  useEffect(() => {
    setIsLoading(loading)
  }, [loading])

  const handleGetDetail = async (data, type) => {
    setIsLoading(true)
    startLoading()
    try {
      // console.log(data)
      const response = await getAssetRegisterWaittingApproveByRequestId(data.id)
      // console.log('response ', response)
      setAssetSchema(response.model)
      setIsAddNumberList(true)
      setActionType(type)

      if (type == 'create') {
        setRegisterId(data.id)
      }
    } catch (e) {
      console.log('error', e)
      notification.open('error', {
        title: e?.response?.data?.errors?.message || DEFAULT_ERR_MSG,
        duration: 5000,
      })

      setRegisterId('')
    }
    doneLoading()
    setIsLoading(false)
  }

  const handleCreateAssetRegisterCode = async () => {
    setSaveLoading(true)
    startLoading()
    try {
      let request = {
        assetRegisterId: registerId,
        assets: selectedList,
      }

      const response = await createRegisterNumber(request)
      // console.log('response ', response)

      if (response.model) {
        onReload({})
      }

      setSelectedList([])
    } catch (e) {
      console.log('error', e)
      notification.open('error', {
        title: e?.response?.data?.errors?.message || DEFAULT_ERR_MSG,
        duration: 5000,
      })
    }
    doneLoading()
    setSaveLoading(false)
  }

  const handleApprove = async (request) => {
    setIsConfirm(0)
    setSaveLoading(true)
    startLoading()
    try {
      const response = await approveRegisterAsset(request)
      // console.log('response ', response)

      if (response.model) {
        onReload({})
      }

      setApproveSelected([])
      setApproveType([])
    } catch (e) {
      console.log('error', e)
      notification.open('error', {
        title: e?.response?.data?.errors?.message || DEFAULT_ERR_MSG,
        duration: 5000,
      })
    }
    doneLoading()
    setSaveLoading(false)
  }

  const onSubmitApprove = (data) => {
    let request = {
      approveType: isConfirm,
      note: data.description,
      assetRegisterIds: approveSelected || [],
    }
    // console.log(JSON.stringify(request))
    handleApprove(request)
  }
  return (
    <>
      {saveLoading && <OverlayLoader />}

      <Table wordWrap autoHeight loading={isLoading} data={tableData} style={{ marginTop: '20px' }}>
        <Column width={100} align="center">
          <HeaderCell>
            <Checkbox
              style={{ marginTop: '-7px' }}
              checked={approveSelected?.length == tableData?.length}
              onChange={(_, checked) => {
                if (checked) {
                  var arr = []
                  var aptArr = []

                  tableData.map((e) => {
                    arr.push(e.id)
                    if (!aptArr.includes(e.assetStatusCode)) {
                      aptArr.push(e.assetStatusCode)
                    }
                  })

                  setApproveSelected(arr)
                  setApproveType(aptArr)
                } else {
                  setApproveSelected([])
                  setApproveType([])
                }
              }}
            >
              {' '}
              <b>ลำดับ</b>
            </Checkbox>
          </HeaderCell>
          <Cell>
            {(rowData, index) => {
              return (
                <Checkbox
                  style={{ marginTop: '-7px' }}
                  checked={approveSelected.filter((e) => e == rowData.id)?.length > 0}
                  onChange={(value, checked) => {
                    console.log(checked)
                    if (checked) {
                      var arr = [...approveSelected]
                      var aptArr = [...approveType]
                      arr.push(rowData.id)

                      if (!aptArr.includes(rowData.assetStatusCode)) {
                        aptArr.push(rowData.assetStatusCode)
                      }

                      setApproveSelected(arr)
                      setApproveType(aptArr)
                    } else {
                      var arr = approveSelected.filter((e) => e !== rowData.id)
                      var aptArr = []

                      tableData.map((e) => {
                        if (!aptArr.includes(e.assetStatusCode) && arr.includes(e.id)) {
                          aptArr.push(e.assetStatusCode)
                        }
                      })

                      setApproveType(aptArr)
                      setApproveSelected(arr)
                    }
                  }}
                >
                  {' '}
                  {index + 1}
                </Checkbox>
              )
            }}
          </Cell>
        </Column>

        <Column width={350} minWidth={350} flexGrow={1}>
          <HeaderCell>โครงการ</HeaderCell>
          <Cell dataKey="projectCode" />
        </Column>

        <Column width={150}>
          <HeaderCell>วันที่ขอขึ้นทะเบียน</HeaderCell>
          <Cell dataKey="requestDate" />
        </Column>

        <Column width={120}>
          <HeaderCell align="center">จำนวนรายการ</HeaderCell>
          <Cell align="right">
            {(rowData) => {
              return <span>{numberThousandSeparator(rowData.totalAsset || 0)}</span>
            }}
          </Cell>
        </Column>

        <Column width={130}>
          <HeaderCell>มูลค่ารวม (บาท)</HeaderCell>
          <Cell align="right">
            {(rowData) => {
              return <span>{budgetFormat(rowData.price || 0)}</span>
            }}
          </Cell>
        </Column>

        <Column width={160}>
          <HeaderCell>สถานะ</HeaderCell>
          <Cell dataKey="assetStatus" />
        </Column>

        {!isViewMode && (
          <Column width={190} align="center" fixed="right">
            <HeaderCell>จัดการรายการ</HeaderCell>
            <Cell>
              {(rowData) => {
                if (rowData.assetStatusCode == '1') {
                  return (
                    <>
                      <Button
                        color="blue"
                        icon={<Icon icon="edit" />}
                        size="sm"
                        disabled={isLoading}
                        onClick={(e) => {
                          handleGetDetail(rowData, 'create')
                        }}
                      >
                        ออกเลขครุภัณฑ์
                      </Button>
                    </>
                  )
                }
                return (
                  <>
                    <SaveButton
                      icon="eye"
                      onClick={() => {
                        handleGetDetail(rowData, 'view')
                      }}
                      disabled={isLoading}
                    >
                      แสดง
                    </SaveButton>
                  </>
                )
              }}
            </Cell>
          </Column>
        )}
      </Table>

      {/* 3ปุ่มล่าง   */}
      {!isViewMode && (
        <>
          <div>
            <br />
            <Row>
              <Col lg={12} md={12} sm={24} xs={24}></Col>
              <Col lg={12} md={12} sm={24} xs={24} style={{ textAlign: 'right' }}>
                <SaveButton
                  onClick={(e) => {
                    setIsConfirm(1)
                  }}
                  disabled={
                    approveSelected.length < 1 ||
                    !approveType.includes('2') ||
                    approveType.includes('1')
                  }
                  icon="check-circle"
                >
                  อนุมัติ
                </SaveButton>
                <EditButton
                  onClick={(e) => {
                    setIsConfirm(2)
                  }}
                  disabled={approveSelected.length < 1 || approveType.includes('2')}
                  icon="check-circle"
                >
                  ส่งกลับแก้ไข
                </EditButton>
                <CancelButton
                  onClick={(e) => {
                    setIsConfirm(3)
                  }}
                  disabled={approveSelected.length < 1 || approveType.includes('2')}
                >
                  ไม่รับขึ้นทะเบียน
                </CancelButton>
              </Col>
            </Row>
          </div>
        </>
      )}

      {/* Modal ปุ่ม ออกเลขครุภัณฑ์  */}

      <Drawer
        full
        // size="lg"
        show={isAddNumberList}
        placement={'top'}
        onHide={() => {
          // setIsShowHistory(false)
          setIsAddNumberList(false)
        }}
      >
        <Drawer.Header>
          <Drawer.Title style={{ height: 30, paddingTop: 10 }}>
            {actionType == 'create' ? 'ออกเลขครุภัณฑ์' : ''}
          </Drawer.Title>
        </Drawer.Header>
        <Drawer.Body>
          {/* สร้าง Table Modal กับ Table Data เพิ่ม */}
          <ModalDurableArticles
            modalSchema={assetSchema}
            isEdit={actionType == 'create'}
            isLoading={isLoading}
            setIsLoading={setIsLoading}
            selectedList={selectedList}
            setSelectedList={setSelectedList}
          />
        </Drawer.Body>
        <Drawer.Footer>
          {actionType == 'create' && (
            <SaveButton
              style={{ marginTop: 0 }}
              onClick={(e) => {
                //setIsAddNumberList(false)
                setIsConfirmAddNumber(true)
                //handleCreateAssetRegisterCode()
              }}
              disabled={isLoading || selectedList.length < 1}
            >
              ออกเลขครุภัณฑ์
            </SaveButton>
          )}
          <CancelButton
            onClick={(e) => {
              setIsAddNumberList(false)
              setSelectedList([])
            }}
            style={{ marginTop: 0 }}
          >
            {actionType == 'create' ? 'ยกเลิก' : 'ปิด'}
          </CancelButton>
        </Drawer.Footer>
      </Drawer>

      {/* <Modal
        full
        show={isAddNumberList}
        onHide={(e) => {
          setIsAddNumberList(false)
        }}
      >
        <Modal.Header>
          <Modal.Title>{actionType == 'create' ? 'ออกเลขครุภัณฑ์' : ''}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
         <div style={{ width: '90vw' }}>
            <ModalDurableArticles
              modalSchema={assetSchema}
              isEdit={actionType == 'create'}
              isLoading={isLoading}
              setIsLoading={setIsLoading}
              selectedList={selectedList}
              setSelectedList={setSelectedList}
            />
          </div>
        </Modal.Body>
        <Modal.Footer>
          {actionType == 'create' && (
            <SaveButton
              style={{ marginTop: 10 }}
              onClick={(e) => {
                //setIsAddNumberList(false)
                setIsConfirmAddNumber(true)
                //handleCreateAssetRegisterCode()
              }}
              disabled={isLoading || selectedList.length < 1}
            >
              ออกเลขครุภัณฑ์
            </SaveButton>
          )}
          <CancelButton
            onClick={(e) => {
              setIsAddNumberList(false)
              setSelectedList([])
            }}
            style={{ marginTop: 10 }}
          >
            {actionType == 'create' ? 'ยกเลิก' : 'ปิด'}
          </CancelButton>
        </Modal.Footer>
      </Modal> */}

      <ConfirmWidget
        title={`ยืนยัน`}
        show={isConfirmAddNumber}
        detail={`ยืนยันการออกเลขครุภัณฑ์ `}
        onCancle={() => setIsConfirmAddNumber(false)}
        onConfirm={() => {
          setIsConfirmAddNumber(false)
          setIsAddNumberList(false)
          handleCreateAssetRegisterCode()
        }}
      />

      {/* Modal 3ปุ่ม   */}

      <Modal
        show={isConfirm > 0}
        overflow={false}
        size="lg"
        onHide={(e) => {
          setIsConfirm(0)
        }}
      >
        <Modal.Header>
          <Modal.Title>
            ระบุรายละเอียด {isConfirm == 1 && 'อนุมัติ'}
            {isConfirm == 3 && 'ไม่รับขึ้นทะเบียน'}
            {isConfirm == 2 && 'ส่งกลับแก้ไข'}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <InputForm
            hideLabel
            disabled={schema.inputForm.description.disabled}
            schema={schema.inputForm.description}
            rows={3}
            componentClass="textarea"
            register={register}
            Controller={Controller}
            control={control}
            errors={errors}
            setValue={setValue}
            clearErrors={clearErrors}
          />
        </Modal.Body>
        <Modal.Footer>
          <SaveButton onClick={handleSubmit(onSubmitApprove)}>
            {isConfirm == 1 && 'อนุมัติ'}
            {isConfirm == 3 && 'ไม่รับขึ้นทะเบียน'}
            {isConfirm == 2 && 'ส่งกลับแก้ไข'}
          </SaveButton>

          <CancelButton
            onClick={(e) => {
              setIsConfirm(0)
            }}
          >
            ยกเลิก
          </CancelButton>
        </Modal.Footer>
      </Modal>
    </>
  )
}
